import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid } from '@material-ui/core';
import Form from '../form/components/Form';
import SubmitButton from '../form/components/SubmitButton';
import { IdPropType, RefPropType } from '../../proptypes/basic';
import TextInput from '../form/components/TextInput';
import { selectFranchiseUrlById, storeFranchiseUrl, updateFranchiseUrl } from '../locations/franchiseUrlsSlice';
import { FRANCHISE_URL_RESOURCE } from '../api/resources';
import { useInitialValues } from '../form/hooks';
import { useCanWrite } from '../abilities/hooks';

const FranchiseUrlForm = ({ locationId, franchiseUrlId, onDone, submitRef }) => {
    const dispatch = useDispatch();
    const franchiseUrl = useSelector((state) => selectFranchiseUrlById(state, franchiseUrlId));
    const canWrite = useCanWrite(FRANCHISE_URL_RESOURCE);
  
    const initialValues = useInitialValues(franchiseUrl, {
        location_id: locationId,
        url: '',
   });

    const handleSubmit = async (values) => {
            const prepped = {
                id: franchiseUrlId,
                ...values,
            };

            return Promise.all([
                dispatch(franchiseUrlId ? updateFranchiseUrl(prepped) : storeFranchiseUrl(prepped)),
            ]).then(([_franchiseUrl]) => (onDone ? onDone(_franchiseUrl) : null));
        };

    return (
        <Form
            initialValues={initialValues}
            validationSchema={null}
            onSubmit={handleSubmit}
            subject={franchiseUrl || FRANCHISE_URL_RESOURCE}
        >
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Grid item xs={12}>
                        <TextInput
                            label="Link"
                            name="url"
                            multiline
                            rows={11}
                            fullWidth
                            disabled={!canWrite}
                        />
                    </Grid>
                </Grid>

                {submitRef ? (
                    <SubmitButton container={submitRef} disabled={!canWrite} />
                ) : (
                    <Grid item xs={12}>
                        <Box textAlign="right">
                            <SubmitButton />
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Form>
    );
};

FranchiseUrlForm.propTypes = {
    customerId: IdPropType.isRequired,
    franchiseUrlId: IdPropType,
    onDone: PropTypes.func,
    submitRef: RefPropType,
};

FranchiseUrlForm.defaultProps = {
    franchiseUrlId: null,
    onDone: () => null,
    submitRef: null,
};

export default FranchiseUrlForm;